import moment from 'moment'

import { CloneLegalCaseGetters } from './partials/clone'
import { ClosingWizardGetters } from './partials/closing-wizard'
import { DocketEntriesGetters } from './partials/docket-entries'
import { DocketEntriesInfoGetters } from './partials/docket-entries-info'
import { ECOPortalIntegrationGetters } from './partials/eco-portal-integration'
import { EngagementLetterGetters } from './partials/engagement-letter'
import { LegalCaseEditGetters } from './partials/edit'
import { LegalCaseTagGetters } from './partials/tag'
import { MyLegalCasesGetters } from './partials/my-legal-cases'
import { ReopeningWizardGetters } from './partials/reopening-wizard'

export const LegalCaseGetters = {
  ...CloneLegalCaseGetters,
  ...ClosingWizardGetters,
  ...DocketEntriesGetters,
  ...DocketEntriesInfoGetters,
  ...ECOPortalIntegrationGetters,
  ...EngagementLetterGetters,
  ...LegalCaseEditGetters,
  ...LegalCaseTagGetters,
  ...MyLegalCasesGetters,
  ...ReopeningWizardGetters,

  currentLegalCase: state => state.legalCases.find(lc => lc.id === state.currentLegalCaseId),
  currentLegalCases: state => state.legalCases,
  legalCase: state => state.legalCase,
  legalCaseOptionsList: state => state.legalCaseOptionsList,
  legalCaseParties: state => state.legalCase.parties,
  legalCaseUnassociatedParties: state => state.legalCaseUnassociatedParties,
  legalCases: state => state.legalCases,
  legalCasesIds: state => state.legalCases.map(item => item.id),
  legalCasesPartySliderSettings: state => state.partySliderSettings,

  // Show open cases first, then most-recently-active first (cases with no
  // docket entries yet sort last within their group). Ties always fall back
  // to id so the order is fully deterministic and doesn't shift on reload,
  // regardless of the order the underlying legal cases were fetched in.
  orderedLegalCases: state => {
    return [...state.legalCases].sort((a, b) => {
      if (!!a.closed !== !!b.closed) return a.closed ? 1 : -1

      if (a.last_created_docket_entry_date !== b.last_created_docket_entry_date) {
        if (!a.last_created_docket_entry_date) return 1
        if (!b.last_created_docket_entry_date) return -1

        // last_created_docket_entry_date arrives as an ISO-8601 timestamp;
        // let moment auto-detect it rather than forcing a format that
        // doesn't match, which would silently produce Invalid Date.
        const aDate = moment(a.last_created_docket_entry_date)
        const bDate = moment(b.last_created_docket_entry_date)
        if (!aDate.isSame(bDate)) return aDate.isBefore(bDate) ? 1 : -1
      }

      return a.id - b.id
    })
  },

  paginationOptions: state => state.paginationOptions,
  showAssociatePartyDialog: state => state.showAssociatePartyDialog,
}
